import React from "react";
import { Link } from "react-router-dom";
import logo from "./Final.png";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
// import { SiGlassdoor } from "react-icons/si";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section - Logo & Social */}
        <div className="footer-left">
          <img src={logo} alt="Company Logo" className="footer-logo" />
          <p>Follow Us On</p>

          <div className="footer-social-icons">
            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/config-server-llp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin size={28} />
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/configserverllp?igsh=MWd3OHc3cWl1NnpteA=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={28} />
            </a>
          </div>
        </div>

        {/* Middle Section - Company Links */}
        <div className="footer-middle">
          <h4>Company</h4>
          <ul>
            <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
            <li><Link to="/about" onClick={scrollToTop}>About</Link></li>
            <li><Link to="/features" onClick={scrollToTop}>Features</Link></li>
            <li><Link to="/services" onClick={scrollToTop}>Services</Link></li>
            <li><Link to="/careers" onClick={scrollToTop}>Careers</Link></li>
            <li><Link to="/contact" onClick={scrollToTop}>Contact us</Link></li>
          </ul>
        </div>

        {/* Right Section - Solutions */}
        <div className="footer-middle">
          <h4>Solutions</h4>
          <ul>
            <li>Digital Transformation</li>
            <li>Product & Platform Development</li>
            <li>Business Intelligence & Data Solutions</li>
            <li>Scalable & Secure Infrastructure</li>
            <li>IT Consulting & Strategy</li>
            <li>Dedicated Teams & IT Staffing</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-right">
          <h4>Contact Us</h4>
          <p><a href="tel:+14849954636">(020) 47211265</a></p>
          <p>Email: <a href="mailto:info@configserverllp.com">info@configserverllp.com</a></p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© 2025 Config Server LLP</p>
      </div>
    </footer>
  );
};

export default Footer;
